import { forwardRef } from 'react';

const TextInput = forwardRef(function TextInput(
  {
    label,
    value,
    onChange,
    disabled = false,
    required = false,
    id,
    inputId,
    name,
    type = 'text',
    placeholder,
    autoComplete,
    onFocus,
    onKeyDown,
    onBlur,
    className = 'form-input',
    ...rest
  },
  ref
) {
  const resolvedId = inputId || id;

  return (
    <>
      {label && <label htmlFor={resolvedId} style={{ fontWeight: 600 }}>{label}</label>}
      <input
        ref={ref}
        id={resolvedId}
        name={name}
        type={type}
        className={className}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        autoComplete={autoComplete}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        {...rest}
      />
    </>
  );
});

export default TextInput;
